import { createSlice } from "@reduxjs/toolkit";

import { getSof } from "../thunks/sofThunk";

interface SofState {
  sofStatement: any[];
  total: number;
  loading: boolean;
  error: string | null;
}

const initialState: SofState = {
  sofStatement: [],
  total: 0,
  loading: false,
  error: null,
};

const sofSlice = createSlice({
  name: "sof",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSof.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSof.fulfilled, (state, action) => {
        state.loading = false;
        state.sofStatement = action.payload?.data || [];
        state.total = action.payload.total;
      })
      .addCase(getSof.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
  },
});

export default sofSlice.reducer;
